export const SUPPORTED_TAGS = ['h1', 'h2', 'h3', 'ul', 'p', 'div'];
